import {
  buildDefaultReferenceListEntries,
  mergeReferenceListEntries,
  resolveReferenceListLabel,
} from "./reference-list-entries.js";

function asStr(v) {
  return String(v ?? "").trim();
}

export const PAYMENT_ENTRY_METHOD_IDS = Object.freeze([
  "cash",
  "bank",
  "card",
  "credit_balance",
  "other",
]);

const LABEL_KEY_BY_ID = Object.freeze({
  cash: "trainerstunden.payments.method.cash",
  bank: "trainerstunden.payments.method.bank",
  card: "trainerstunden.payments.method.card",
  credit_balance: "trainerstunden.payments.method.creditBalance",
  other: "trainerstunden.payments.method.other",
});

/**
 * @returns {import('./reference-list-entries.js').ReferenceListEntry[]}
 */
export function defaultPaymentEntryMethodEntries() {
  return buildDefaultReferenceListEntries(PAYMENT_ENTRY_METHOD_IDS);
}

/**
 * @param {unknown} lists
 */
export function resolvePaymentEntryMethodEntries(lists) {
  const configured =
    lists && typeof lists === "object" ? lists.paymentEntryMethods : null;
  return mergeReferenceListEntries(
    configured,
    defaultPaymentEntryMethodEntries(),
  );
}

/**
 * @param {unknown} lists
 */
export function resolvePaymentEntryMethodEntriesForAdmin(lists) {
  const configured =
    lists && typeof lists === "object" ? lists.paymentEntryMethods : null;
  return mergeReferenceListEntries(
    configured,
    defaultPaymentEntryMethodEntries(),
    { adminView: true },
  );
}

/**
 * @param {{ id: string, label?: string }} entry
 * @param {(key: string) => string} t
 */
export function resolvePaymentEntryMethodLabel(entry, t) {
  return resolveReferenceListLabel(entry, t, (id) => LABEL_KEY_BY_ID[id] || "");
}

/**
 * @param {unknown} lists
 * @returns {string[]}
 */
export function resolvePaymentEntryMethodIds(lists) {
  return resolvePaymentEntryMethodEntries(lists).map((row) => row.id);
}

/**
 * @param {string} methodId
 * @param {unknown} lists
 * @param {(key: string) => string} t
 */
export function resolvePaymentEntryMethodLabelById(methodId, lists, t) {
  const id = asStr(methodId);
  if (!id)
    return typeof t === "function"
      ? t("trainerstunden.planning.fieldDash")
      : "";
  const entry = resolvePaymentEntryMethodEntries(lists).find(
    (row) => row.id === id,
  );
  if (entry) return resolvePaymentEntryMethodLabel(entry, t);
  const key = LABEL_KEY_BY_ID[id];
  if (key && typeof t === "function") {
    const translated = t(key);
    if (translated !== key) return translated;
  }
  return id;
}

/**
 * @param {string} methodId
 * @param {unknown} lists
 */
export function isAllowedPaymentEntryMethodId(methodId, lists) {
  const id = asStr(methodId);
  if (!id) return false;
  return resolvePaymentEntryMethodIds(lists).includes(id);
}
